const BLOCKED_SCHEMES = /^(javascript|data|vbscript|blob):/i;

/**
 * Returns a safe http(s) URL for iframe/script loading, or undefined when rejected.
 */
export const sanitizeGameUrl = (rawUrl: unknown): string | undefined => {
  if (typeof rawUrl !== 'string') {
    return undefined;
  }

  const trimmed = rawUrl.trim();
  if (!trimmed || BLOCKED_SCHEMES.test(trimmed)) {
    return undefined;
  }

  try {
    const parsed = new URL(trimmed, window.location.href);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return undefined;
    }

    return parsed.href;
  } catch {
    return undefined;
  }
};
